import Burz from './Burz'
import Cornelius from './Cornelius'
import React from 'react'

class Team extends React.Component {
  render() {
    return (
      <div>
        <center>
          <h1 className="title is-1">Our Team</h1>
        </center>
        <div className="field">
          <Burz />
        </div>
        <div className="field">
          <Cornelius />
        </div>
      </div>
    )
  }
}

export default Team



// WEBPACK FOOTER //
// ./src/Team.js